import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiGift, FiPlay, FiStar } = FiIcons;

const BonusSection = () => {
  return (
    <section className="py-20 px-4 bg-gradient-to-br from-[#556B2F] to-[#6082B6] text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-20 h-20 border-2 border-white rounded-full"></div>
        <div className="absolute top-40 right-20 w-16 h-16 border-2 border-white rounded-full"></div>
        <div className="absolute bottom-20 left-1/4 w-12 h-12 border-2 border-white rounded-full"></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10">
        {/* Special Tag */}
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-8"
        >
          <div className="inline-flex items-center space-x-2 bg-[#E07A5F] px-6 py-3 rounded-full shadow-lg">
            <SafeIcon icon={FiGift} className="text-xl" />
            <span className="font-bold text-lg" style={{ fontFamily: 'Kanit, sans-serif' }}>
              ข้อเสนอพิเศษ! สั่งซื้อวันนี้ รับฟรีทันที!
            </span>
          </div>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Video Course Mockup */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="bg-white rounded-2xl p-6 shadow-2xl transform hover:scale-105 transition-transform duration-300">
              <div className="relative bg-gradient-to-br from-gray-800 to-gray-900 rounded-xl overflow-hidden">
                <img 
                  src="https://static.wixstatic.com/media/4fbfa6_d8ac54a7a1dd459abcc3031a27d29bdf~mv2.png" 
                  alt="E-Course Video - แค่หายใจก็เหนื่อย" 
                  className="w-full h-48 object-cover" 
                />
                <div className="absolute inset-0 flex items-center justify-center bg-black/30">
                  <div className="bg-[#E07A5F] rounded-full p-4 shadow-lg hover:scale-110 transition-transform duration-300 cursor-pointer">
                    <SafeIcon icon={FiPlay} className="text-3xl text-white" />
                  </div>
                </div>
              </div>
              <div className="mt-4 text-center">
                <div className="flex items-center justify-center space-x-1 mb-2">
                  {[...Array(5)].map((_, i) => (
                    <SafeIcon key={i} icon={FiStar} className="text-yellow-400 text-sm" />
                  ))}
                </div>
                <p className="text-gray-600 text-sm" style={{ fontFamily: 'Sarabun, serif' }}>
                  คอร์สวิดีโอคุณภาพสูง HD
                </p>
              </div>
            </div>
          </motion.div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            viewport={{ once: true }}
          >
            <h2 className="text-4xl md:text-5xl font-bold mb-6" style={{ fontFamily: 'Kanit, sans-serif' }}>
              E-Course VDO <br />
              <span className="text-[#E07A5F]">"24 จังหวะชีวิตฉบับจับมือทำ"</span>
            </h2>

            <div className="mb-6">
              <span className="text-2xl line-through opacity-75">มูลค่า 3,999 บาท</span>
              <span className="ml-4 text-3xl font-bold text-[#E07A5F]">ฟรี!</span>
            </div>

            <p className="text-lg leading-relaxed mb-8 opacity-90" style={{ fontFamily: 'Sarabun, serif' }}>
              ย่อยเนื้อหาจากหนังสือให้เข้าใจง่ายขึ้นไปอีกขั้น! เรียนรู้ผ่านวิดีโอคุณภาพสูง พร้อม Workshop ที่จะช่วยให้คุณนำ "24 ซีซั่น" ไปปรับใช้กับชีวิตประจำวันได้ทันที
            </p>

            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20">
              <p className="text-sm font-semibold text-[#E07A5F]" style={{ fontFamily: 'Kanit, sans-serif' }}>
                ⚠️ ของแถมมีจำนวนจำกัด
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default BonusSection;